import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { verifyToken } from "src/actions/auth";
import ResetPasswordUrlInvalid from "src/components/Auth/ResetPasswordUrlInvalid";
import WelcomePasswordContent from "src/components/Auth/WelcomePasswordContent";
import Preloader from "src/components/Shared/LoadingAnimations/Preloader";

const WelcomePassword = ({ verifyToken }) => {
  const [status, setStatus] = useState("pending");
  const params = useParams();

  const loadOut = {
    pending: <Preloader />,
    failed: <ResetPasswordUrlInvalid url="/forgot-password/submit-email" />,
    success: <WelcomePasswordContent token={params.token || null} />,
  };

  useEffect(() => {
    const ac = new AbortController();

    const loadToken = async () => {
      try {
        await verifyToken({ token: params.token || null }, ac.signal);
        setStatus("success");
      } catch (error) {
        setStatus("failed");
      }
    };

    loadToken();

    return () => ac.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return loadOut[status];
};

export default connect(null, { verifyToken })(WelcomePassword);
